module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("教材价格列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("添加教材价格")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/materialPrice/listByPage",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑教材价格"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材价格",
      "prop": "price"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.price),
      callback: function($$v) {
        _vm.$set(_vm.formData, "price", _vm._n($$v))
      },
      expression: "formData.price"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33879e3b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/CoursePriceList.vue
// module id = 1740
// module chunks = 8